<script>
import { mapState } from 'pinia';

import { useUserStore } from '@store/useUserStore.js';
import CpTooltip from '@resources/js/tooltip.vue';
import CpTooltipToggle from '@resources/js/tooltip-toggle.vue';
import MemberContent from './MemberContent.vue';

export default {
  name: 'CpMemberComponent',
  components: {
    CpTooltip,
    CpTooltipToggle,
    UserHoverOverlay: () => import('@resources/js/components/UserHoverOverlay.vue'),
    MemberContent,
  },
  props: {
    member: { type: Object, default: () => ({}) },
    maxLines: { type: Number, default: 2 },
    tag: { type: String, default: '' },
    withHoverOverlay: { type: Boolean, default: false },
    nameClass: { type: String, default: '' },
    descriptionClass: { type: String, default: '' },
    imageSize: { type: String, default: '40px' },
    displayButtons: { type: Boolean, default: true },
  },
  computed: {
    tooltipId() {
      return 'member-hover-' + this._uid;
    },
    isOwner() {
      return this.member?.id == this.userProfileData?.id;
    },
    ...mapState(useUserStore, ['userProfileData']),
  },
};
</script>

<template>
  <span v-if="withHoverOverlay && !isOwner" class="member-component-container">
    <CpTooltipToggle :for="tooltipId" hoverable>
      <MemberContent :member="member" :max-lines="maxLines" :tag="tag" :nameClass="nameClass" :descriptionClass="descriptionClass" :imageSize="imageSize">
        <template v-if="$scopedSlots.image" #image>
          <slot name="image" />
        </template>
        <template v-if="$scopedSlots.customDescription" #customDescription>
          <slot name="customDescription" />
        </template>
      </MemberContent>
    </CpTooltipToggle>
    <CpTooltip :id="tooltipId" light :ignore-hash-change="true">
      <UserHoverOverlay :member="member" :displayButtons="displayButtons" />
    </CpTooltip>
  </span>
  <MemberContent v-else :member="member" :max-lines="maxLines" :tag="tag" :nameClass="nameClass" :descriptionClass="descriptionClass" :imageSize="imageSize">
    <template v-if="$scopedSlots.image" #image>
      <slot name="image" />
    </template>
    <template v-if="$scopedSlots.customDescription" #customDescription>
      <slot name="customDescription" />
    </template>
  </MemberContent>
</template>
<style scoped>
.member-component-container {
  width: fit-content;
  align-self: flex-start;
  text-align: left;
}
</style>
